export const PADDING_LEFT_RIGHT = "1.625em";
